// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .pair-button {
    border-radius: 10px;
    font-size: 18px;
    align-self: center;
    color: white;
    text-align: center;
    background: rgba(237, 109, 5);
    text-transform: uppercase;
    padding: 8px 50px;
    pointer-events: fill;
    z-index: 9999;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/components/super-pro/super-pro-page.ts"],"names":[],"mappings":";EACE;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;EACf","sourcesContent":["\n  .pair-button {\n    border-radius: 10px;\n    font-size: 18px;\n    align-self: center;\n    color: white;\n    text-align: center;\n    background: rgba(237, 109, 5);\n    text-transform: uppercase;\n    padding: 8px 50px;\n    pointer-events: fill;\n    z-index: 9999;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
